module.exports = __webpack_public_path__ + "static/media/user-silhouette.56902ef6.svg";